import React from "react"
import privacypolicy from "../assets/imgs/privacypolicy.jpg"

const PrivacyPolicy = () => {
    return (
        <>
            <main id="main">
                <section id="breadcrumbs" class="d-flex align-items-center" style={{ background: `url(${privacypolicy})`, backgroundSize: "cover" }}>
                    <div class="container position-relative" data-aos="fade-up" data-aos-delay="500">
                        <h1 class="pt-3">Privacy Policy</h1>
                    </div>
                </section>
                <section id="privacypolicy" class="privacypolicy" style={{ paddingTop: "0", paddingBottom: "0" }}>
                    <div class="container p-3 p-lg-5 pt-2">
                        <div class="section-title" data-aos="fade-up">
                            <h2 class="pt-3">Our Privacy Policy</h2>
                        </div>
                        <div className="lg:pt-[60px] lg:pb-[60px] pb-[180px]">
                            <div className="theme-container mx-auto">
                                <div className="body-content-wrapper lg:col-span-8 mb-10 lg:mb-0">
                                    <div className="grid items-center">
                                        <div className="article-area">
                                            <p className="sm:text-sm sm:leading-8 text-sm font-bold spline-sans text-white mb-5">
                                                <strong>Last Updated: 29th January, 2026</strong>
                                            </p>
                                            <p className="text-base leading-[27px] text-white mb-[20px]">
                                                Fintrek Marketing is committed to protecting your privacy.
                                                This policy outlines how we collect, use, and safeguard your
                                                personal information.
                                            </p>

                                            <p className="items-center pb-[5px] pt-4">
                                                <span className="custom-heading">
                                                    <strong>Information We Collect</strong>
                                                </span>
                                            </p>
                                            <p className="custom-content">
                                                We may collect the following types of personal information:
                                                <ul className="pl-3">
                                                    <li> Contact information (name, email, phone number, address).</li>
                                                    <li> Financial information (income, assets, liabilities).</li>
                                                    <li> Employment information.</li>
                                                    <li> Data related to your loan and credit needs.</li>
                                                    <li> Information about your preferences and requirements.</li>
                                                </ul>
                                            </p>

                                            <p className="items-center pb-[5px] pt-4">
                                                <span className="custom-heading">
                                                    <strong>How We Use Your Information</strong>
                                                </span>
                                            </p>
                                            <p className="custom-content">
                                                We use the information provided, for:
                                                <ul className="pl-3">
                                                    <li> Providing and improving our services.</li>
                                                    <li> Communicating with you and responding to inquiries.</li>
                                                    <li> Customizing your experience and recommendations.</li>
                                                    <li> Legal and regulatory compliance.</li>
                                                </ul>
                                            </p>

                                            <p className="items-center pb-[5px] pt-4">
                                                <span className="custom-heading">
                                                    <strong>Information Sharing</strong>
                                                </span>
                                            </p>
                                            <p className="custom-content">
                                                We may share your information with:
                                                <ul className="pl-3">
                                                    <li> Third-party service providers assisting with services.</li>
                                                    <li> Financial institutions for loan or credit applications.</li>
                                                    <li> Government authorities when required by law.</li>
                                                </ul>
                                            </p>

                                            <p className="items-center pb-[5px] pt-4">
                                                <span className="custom-heading">
                                                    <strong>Security</strong>
                                                </span>
                                            </p>
                                            <p className="custom-content">
                                                We are committed to ensuring that your information
                                                is secure. We implement physical, electronic, and
                                                managerial measures to safeguard your data.
                                            </p>

                                            <p className="items-center pb-[5px] pt-4">
                                                <span className="custom-heading">
                                                    <strong>Your Rights</strong>
                                                </span>
                                            </p>
                                            <p className="custom-content">
                                                You can request access, modification, or deletion of
                                                your personal data by contacting us at
                                                <strong>about@fintrekmarketing.com.</strong>
                                            </p>

                                            <p className="items-center pb-[5px] pt-4">
                                                <span className="custom-heading">
                                                    <strong>Changes to This Privacy Policy</strong>
                                                </span>
                                            </p>
                                            <p className="custom-content">
                                                We may update this Privacy Policy from time to time.
                                                Any changes will be posted on this page.
                                            </p>

                                            <p className="items-center pb-[5px] pt-4">
                                                <span className="custom-heading">
                                                    <strong>Contact Us</strong>
                                                </span>
                                            </p>
                                            <p className="custom-content">
                                                If you have any questions about our Privacy Policy,
                                                please contact us at
                                                <strong> about@fintrekmarketing.com </strong>
                                                or <strong> +971 458 10404</strong>.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </main>
        </>
    )
}

export default PrivacyPolicy
